/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [{
    url: "/dashboard-financial",
    name: "Dashboard",
    icon: "PieChartIcon",
    slug: "dashboard",
    i18n: "dashboard",
},
{
    url: '/financial-parameterization-products-and-services',
    name: "Gestão de Acesso aos Produtos",
    slug: "financial",
    icon: "LockIcon",
    i18n: "financial-parameterization-products-and-services",
},
{
    url: '/financial-parameterization-messages',
    name: "Parametrização de Alertas",
    slug: "financial-messages",
    icon: "MessageCircleIcon",
    i18n: "financial-parameterization-messages",
},
{
    url: "/account-information-and-balances",
    name: "Informações e saldos",
    icon: "TrendingUpIcon",
    slug: "account-information-and-balances",
    i18n: "account-information-and-balances"
},
{
    url: "/transfer-of-values",
    name: "Transferência de Valores",
    icon: "RefreshCcwIcon",
    slug: "transfer-of-values",
    i18n: "transfer-of-values"
},
{
    url: '/financeiro',
    name: "Financeiro",
    slug: "financial",
    icon: "DollarSignIcon",
    i18n: "financial",
    submenu: [{
        url: "/conciliation-balance",
        name: "Conciliação de saldos",
        slug: "conciliation-balance",
        i18n: "conciliation-balance"
    },
    {
        url: "/financial-statement-filoo",
        name: "Extrato financeiro Filóo",
        slug: "financial-statement-filoo",
        i18n: "financial-statement-filoo"
    },
    {
        url: "/transaction-report",
        name: "Movimentações",
        slug: "transaction-report",
        i18n: "transaction-report"
    },
      {
        url: "/block-balance",
        name: "Bloqueio de saldos",
        slug: "block-balance",
        i18n: "block-balance"
      },
    ],

},
{
    url: '/reports-financial',
    name: "Relatórios",
    slug: "reports-financial",
    icon: "FileTextIcon",
    i18n: "reports-financial",
    submenu: [
        {
            url: "/pf-customers-report",
            name: "Clientes em geral",
            slug: "pf-customers-report",
            i18n: "pf-customers-report"
        },
        {
            url: "/medical-appointments-performed-x-rps",
            name: "Consultas Realizadas x Nº da Venda",
            slug: "medical-appointments-performed-x-rps",
            i18n: "medical-appointments-performed-x-rps"
        },
        {
            url: "/pool-extract-report",
            name: "Extrato conta pool",
            slug: "invoice-report",
            i18n: "invoice-report"
        },
        {
            url: "/iugu-report",
            name: "Extrato de Contas Iugu",
            slug: "iugu-report",
            i18n: "iugu-report"
        },
        {
            url: "/invoice-report",
            name: "Faturas Iugu",
            slug: "invoice-report",
            i18n: "invoice-report"
        },
        {
            url: "/quicksight-financial-dashboard",
            name: "Painéis BI",
            slug: "quicksight-financial-dashboard",
            i18n: "quicksight-financial-dashboard",
        },
        {
            url: "/exposure-report",
            name: "Relatório de Exposição",
            slug: "exposure-report",
            i18n: "exposure-report",
        },
        {
            url: "/tax-report",
            name: "Relatório de Tarifas",
            slug: "tax-report",
            i18n: "tax-report",
        },
        {
            url: "/withdraw-report",
            name: "Saques",
            slug: "withdraw-report",
            i18n: "withdraw-report"
        },
        {
            url: "/aas-sales-commission-report",
            name: "Comissão de Vendas",
            slug: "aas-sales-commission-report",
            i18n: "aas-sales-commission-report"
        },
        {
            url: "/commissioning-by-subscription",
            name: "Comissionamento por Assinatura",
            slug: "commissioning-by-subscription",
            i18n: "commissioning-by-subscription"
        },
    ],

},
{
    url: '/financial-statement-filoo',
    name: "Extrato Filóo",
    slug: "statement",
    icon: "ListIcon",
    i18n: "statement",
    submenu: [{
        url: "/professionals-statement",
        name: "Extrato profissionais",
        slug: "professionals-statement",
        i18n: "professionals-statement"
    },
    {
        url: "/client-statement",
        name: "Extrato clientes",
        slug: "client-statement",
        i18n: "client-statement"
    },
    {
        url: "/inactivated",
        name: "Inativados",
        slug: "inactivated",
        i18n: "inactivated"
    },
    ],
},
]
